const stripe = Stripe('pk_live_l7c5zZne028R3EEMEmSUutgP00vqebGe5i');

export default stripe
